import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FundAttributionEntryComponent } from './fund-attribution-entry/fund-attribution-entry.component';
import { FundAttributionComponent } from './fund-attribution/fund-attribution.component';
import { SharedModule } from '@shared/shared.module';
import {
  ComponentMapping,
  DynamicModule,
} from '@services/module-loader.config';
import { TimeperiodDataComponent } from './fund-attribution/timeperiod-data/timeperiod-data.component';
import { ButtonModule } from '@frk/eds-components';

@NgModule({
  declarations: [
    FundAttributionEntryComponent,
    FundAttributionComponent,
    TimeperiodDataComponent,
  ],
  imports: [CommonModule, SharedModule, ButtonModule],
  entryComponents: [FundAttributionEntryComponent, FundAttributionComponent],
})
export class FundAttributionModule implements DynamicModule {
  getComponentMapping(): ComponentMapping {
    return {
      'Fund Attribution': FundAttributionEntryComponent,
    };
  }
}
